'use strict';

const _=require('pulsar-utils/dist-es6/_');

const cx=require('../../../dist-es6/shared/extensions/classExtensions');
const DashboardPersonViewModel=require('../../../dist-es6/client/viewModels/dashboardPersonViewModel');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const fpe=require('pulsar-dashboard-core/dist-es6/extensions/fatiguePointExtensions');
const fe=require('../../../dist-es6/shared/extensions/fatigueExtensions');
const ae=require('../../../dist-es6/shared/extensions/assessmentsExtensions');

const FifteenMinutesInMilliseconds=timespan.fromMinutes(15).totalMilliseconds();
const TwentyFourHourTimespan=timespan.fromHours(24);
const ExpectedNormalWorkdayInHours=14;
const ZeroDuration=timespan.fromMinutes(0);

const NotApplicableAlertInfo={
label:'N/A',
interval:null,
status:ThresholdStatus.NotApplicable};let


ForecastPersonViewModel=class ForecastPersonViewModel extends DashboardPersonViewModel{
constructor(...args){
super(...args);
this._currentStatusSource=_.exists(this,'statistics.effectiveStatus.time')?'effectiveStatus':'lastKnownStatus';

cx(this).defineLazyGetters({
forecast:()=>_.get(this,'statistics.forecast',null),
schedule:()=>_.get(this,'statistics.forecast.schedule',null),
scenario:()=>_.get(this,'statistics.forecast.scenario',null),
predictedWorkday:()=>_.get(this,'statistics.forecast.predictedWorkday',null),
pastShifts:()=>_.get(this,'statistics.forecast.pastShifts',[]),
timeRemaining:()=>this._getRemainingWorkdayDuration(),
isPlannedWorkday:()=>_.get(this,'statistics.forecast.isPlannedWorkday',!1),
workdayStart:()=>_.get(this,'statistics.forecast.predictedWorkday.start',null),
currentHosStatus:()=>_.get(this,'statistics.forecast.currentHosStatus',null),
incidents:()=>_.get(this,'statistics.forecast.incidents',null),
assessments:()=>ae(_.sortBy(_.get(this,'statistics.forecast.assessments',[]),a=>a.time.getTime())).
filterOutFutureShifts({now:this.currentTimeForForecast,currentShift:this.predictedWorkday}),
assessmentsInLast24Hours:()=>this._getAssessmentsInLast24Hours(),
effectiveStatus:()=>_.get(this,'statistics.effectiveStatus',null),
isAlertingSinceStart:()=>this.currentAlertInfo&&
this.currentAlertInfo.status.value==='Above'&&
_.result(this,'scenario.fatigue[0].time.getTime')===this.currentAlertInfo.interval.start.getTime(),

currentAlertInfo:()=>this.getAlertInfoAt(this.currentTimeForForecast),
currentThreshold:()=>this.thresholdFor(_.get(this,'statistics.visualNotificationType',NotificationType.AllThresholdsExceeded)),

currentStatus:()=>this._getCurrentStatus(),
_realCurrentStatus:()=>this._getRealCurrentStatus(),

fatigueWithStatuses:()=>[...fpe(_.get(this,'scenario.fatigue',[])).withAlertStatusesAndInterpolations(this.currentThreshold)],

alertRanges:()=>this._getAlertRanges(),
visibleAlertRanges:()=>this.statistics.alertsSource==='assessments'?this._getVisibleAlertRangesFromAssessments():this._getVisibleAlertRangesFromFatigue(),
peakWorkdayTimeSeriesPoint:()=>this._getPeakWorkdayTimeSeriesPoint(),
peakWorkdayFatigue:()=>_.get(this.peakWorkdayTimeSeriesPoint,'value',null),

combinedDuties:()=>TimeInterval.compress(_.get(this,'schedule.duties',[])),

inServiceViolation:()=>this.predictedWorkday&&this.predictedWorkday.duration.totalHours()!==ExpectedNormalWorkdayInHours});

}

get currentTimeForForecast(){
return this.statistics.currentTime;
}

getAlertInfoAt(time){
if(_.isDate(time)&&!Number.isNaN(time.getTime())){
const visibleAlertInfo=_getAlertInfoFor({
alertRanges:{
Above:TimeInterval.compress(this.visibleAlertRanges.past.Above.concat(this.visibleAlertRanges.future.Above)),
At:TimeInterval.compress(this.visibleAlertRanges.past.At.concat(this.visibleAlertRanges.future.At)),
Below:TimeInterval.compress(this.visibleAlertRanges.past.Below.concat(this.visibleAlertRanges.future.Below)),
NotApplicable:TimeInterval.compress(this.visibleAlertRanges.past.NotApplicable.concat(this.visibleAlertRanges.future.NotApplicable))},

time,
prioritizeTimeOverThresholdStatus:this.statistics.alertsSource==='assessments'});


if(_.exists(visibleAlertInfo)){
return _.assign(visibleAlertInfo,{
urgent:visibleAlertInfo.status===ThresholdStatus.Above&&visibleAlertInfo.label==='current'&&this._realCurrentStatus.onDuty});

}
}

return NotApplicableAlertInfo;
}

_getRemainingWorkdayDuration(){
if(!this.predictedWorkday||this.predictedWorkday.end.getTime()<=this.currentTimeForForecast.getTime()){
return ZeroDuration;
}

return timespan.fromMilliseconds(this.predictedWorkday.end.getTime()-this.currentTimeForForecast.getTime());
}

_getRealCurrentStatus(){
const currentStatus=_.get(this,this._currentStatusSource,{});

if(!_.isDate(currentStatus.time)){
currentStatus.time=new Date(currentStatus.time);
}

if(currentStatus.fatigue){
currentStatus.thresholdStatus=ThresholdStatus.fromScoreAndThreshold(currentStatus.fatigue,this.currentThreshold);
}

return currentStatus;
}

_getAlertRanges(){
const alertIntervals=_getFreshAlertIntervals();

if(!this._thresholdCache||!this.scenario){
return alertIntervals;
}

const threshold=this.currentThreshold;

return fpe(this.scenario.fatigue).getAlertRangesFor(threshold);
}

_getVisibleAlertRangesFromFatigue(){
const{scenario,schedule,predictedWorkday}=this;

const visibleAlertRanges={
past:_getFreshAlertIntervals(),
future:_getFreshAlertIntervals()};


if(!scenario||!predictedWorkday){
return visibleAlertRanges;
}

const currentUnixTime=this.currentTimeForForecast.getTime();
const threshold=this.currentThreshold;

const alertableIntervals=this.statistics.intervalTypesWithThresholdStatus.includes('duty')?
this.combinedDuties:
_.flatMap(this.statistics.intervalTypesWithThresholdStatus,intervalType=>_.get(schedule,intervalType+'s',[]).concat(_.get(scenario,intervalType+'s',[])));

if(this.isPlannedWorkday){

const[flights,dutiesOrTrips]=_.partition(alertableIntervals,i=>_.exists(i.tod));

const pastInterval=TimeInterval.from(pulsarDate.MinDate()).to(currentUnixTime);
const futureInterval=TimeInterval.from(currentUnixTime).to(pulsarDate.MaxDate());

const[flightsWithTodInPast,flightsWithTodInFuture]=_.partition(flights,f=>pastInterval.contains(f.tod));

const pastAlertableClippedIntervals=TimeInterval.clip(dutiesOrTrips).to(pastInterval);
visibleAlertRanges.past=fpe(scenario.fatigue).getAlertRangesOverlapping(threshold,pastAlertableClippedIntervals.concat(flightsWithTodInPast));

const futureAlertableClippedIntervals=TimeInterval.clip(dutiesOrTrips).to(futureInterval);
visibleAlertRanges.future=fpe(scenario.fatigue).getAlertRangesOverlapping(threshold,futureAlertableClippedIntervals.concat(flightsWithTodInFuture));

return visibleAlertRanges;
}

if(predictedWorkday.start.getTime()<currentUnixTime){
const pastPredictionWindow=TimeInterval.from(predictedWorkday.start).to(currentUnixTime);
const pastAlertableIntervals=TimeInterval.clip(alertableIntervals).to(pastPredictionWindow);

if(pastAlertableIntervals.length){
visibleAlertRanges.past=fpe(scenario.fatigue).getAlertRangesOverlapping(threshold,pastAlertableIntervals);
}
}

if(currentUnixTime<predictedWorkday.end.getTime()){
const futurePredictionWindow=TimeInterval.from(currentUnixTime).to(predictedWorkday.end);

visibleAlertRanges.future=fpe(scenario.fatigue).getAlertRangesOverlapping(threshold,[futurePredictionWindow]);
}

return visibleAlertRanges;
}

_getVisibleAlertRangesFromAssessments(){

return{
past:ae(this.assessments).getAlertRangesFor(TimeInterval.from(this.statistics.visibleBounds.start).to(this.currentTimeForForecast)),
future:_getFreshAlertIntervals()};

}

_getPeakWorkdayTimeSeriesPoint(){
const workdayDutyPeriodsIncludingFuture=_.compact(_.concat(..._.values(this.visibleAlertRanges.past),..._.values(this.visibleAlertRanges.future)));
const peakFatigue=fe(this.fatigueWithStatuses).peakConsistentWithFatigueApi(workdayDutyPeriodsIncludingFuture);
fe.tagIfForecasted(peakFatigue,this.currentTimeForForecast);

return peakFatigue;
}

_getCurrentStatus(){
const currentStatus=this._getCurrentStatusWithLastPointBeforeCurrentTime();
if(this.statistics.alertsSource==='assessments'){
_.set(currentStatus,'thresholdStatus',this._getCurrentAssessmentStatus());
}
return currentStatus;
}

_getCurrentAssessmentStatus(){
const currentAlertInfo=_.get(this,'currentAlertInfo');
if(currentAlertInfo&&currentAlertInfo.label==='current'){
return currentAlertInfo.status;
}

return ThresholdStatus.Below;
}

_getCurrentStatusWithLastPointBeforeCurrentTime(){
const realCurrentStatus=this._realCurrentStatus;

const interpolatedCurrentPoint=_.findLast(this.fatigueWithStatuses,tsp=>tsp.time.getTime()<=this.currentTimeForForecast.getTime());

if(!_.exists(interpolatedCurrentPoint)){
return realCurrentStatus;
}

return _.defaults({
fatigue:interpolatedCurrentPoint.value,
thresholdStatus:interpolatedCurrentPoint.status,
time:interpolatedCurrentPoint.time},
realCurrentStatus);
}

_getAssessmentsInLast24Hours(){
if(!this.assessments){
return[];
}

const last24HoursInterval=TimeInterval.from(this.currentTimeForForecast.getTime()-TwentyFourHourTimespan.totalMilliseconds()).to(this.currentTimeForForecast);

return this.assessments.filter(a=>last24HoursInterval.contains(a.time));
}};


const _getFreshAlertIntervals=()=>({
Above:[],
At:[],
Below:[],
NotApplicable:[]});


const alertInfoTypes=[{
label:'current',
predicate:(interval,time)=>interval.contains(time)},
{
label:'future',
predicate:(interval,time)=>interval.start.getTime()>time.getTime(),
setup:intervals=>intervals.slice().reverse()},
{
label:'recent',
predicate:(interval,time)=>interval.end.getTime()<time.getTime()}];


const ThresholdStatusesInDescendingPrecedence=['Above','At','Below','NotApplicable'];

function _getAlertInfoFor({alertRanges,time,prioritizeTimeOverThresholdStatus=!1}){
return prioritizeTimeOverThresholdStatus===!0?
_getAlertInfoPrioritizingCurrentTime({alertRanges,time}):
_getAlertInfoPrioritizingThresholdStatus({alertRanges,time});
}

const _tryGetResultFor=(alertRanges,infoType,rangeType,time)=>{
const{label,predicate,setup=_.identity}=infoType;
const intervals=setup(alertRanges[rangeType]);

const foundInterval=intervals.find(ti=>predicate(ti,time));

if(!_.exists(foundInterval)){
return;
}

return{
interval:foundInterval,
status:ThresholdStatus[rangeType],
label};

};

function _getAlertInfoPrioritizingThresholdStatus({alertRanges,time}){
for(const rangeType of ThresholdStatusesInDescendingPrecedence){
for(const infoType of alertInfoTypes){
const result=_tryGetResultFor(alertRanges,infoType,rangeType,time);

if(_.exists(result)){
return result;
}
}
}
}

function _getAlertInfoPrioritizingCurrentTime({alertRanges,time}){
for(const infoType of alertInfoTypes){
for(const rangeType of ThresholdStatusesInDescendingPrecedence){
const result=_tryGetResultFor(alertRanges,infoType,rangeType,time);

if(_.exists(result)){
return result;
}
}
}
}

module.exports=ForecastPersonViewModel;
//# sourceMappingURL=forecastPersonViewModel.js.map
